// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"5a2c2f8a","486":"4c0a084b","592":"9b98a20c"}[chunkId] + ".chunk.js";
};